import React, { useState, useEffect } from 'react'
import axios from 'axios';
import Cards from '../cards/Cards'
import { useLocation, useNavigate } from 'react-router';
import "./RelatedProducts.css"

function RelatedProducts(props) {

    const [clothes, setClothes] = useState([]);
    const product = props.product
    const category = product.category.toLowerCase()

    
    useEffect(() => {
        async function fetchClothes() {
            setClothes([{}]);
            try {
                const response = await axios.get(`https://jackpotbackend.vercel.app/${category}/all`);
                setClothes(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchClothes();
    }, []);

    const filteredClothes = clothes.filter(shirt => shirt.id !== product.id);
    const TypeFilteredClothes = filteredClothes.filter(shirt => shirt.type === product.type) //for later use
   
    return (
        <div className='totalContent related-products-div'>
            <hr className='relatedHr' />
            <div className='content '  >

                <h1 >Related Products</h1>
                <div className='content-item'>
                    {filteredClothes.map((shirt, id) => (
                        <div className='' >
                            <Cards key={id} shirt={shirt} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default RelatedProducts